import { useStore } from "effector-react";
import { $isAudioLoading, $isAudioPlaying } from "frontend/src/domain/audio";
import { useIsPlaylistSelectedForPlayer, useIsPlaylistTrackSelectedForPlayer, useIsSearchedTrackSelectedForPlayer, useIsTimetableSelectedForPlayer, useIsUserFileSelectedForPlayer, } from "frontend/src/domain/player-track-queue";
import { useIsThisPlaylistLoading, useIsThisTimetableLoading, } from "frontend/src/features/load-player-tracks-source";
export var usePlaylistRelationToPlayer = function (playlistId) {
    var isTrackSourceLoading = useIsThisPlaylistLoading(playlistId);
    var isSelectedForPlayer = useIsPlaylistSelectedForPlayer(playlistId);
    var isAudioLoading = useStore($isAudioLoading);
    var isAudioPlaying = useStore($isAudioPlaying);
    var isLoading = isSelectedForPlayer && (isTrackSourceLoading || isAudioLoading);
    var isPlaying = isSelectedForPlayer && isAudioPlaying;
    return { isSelectedForPlayer: isSelectedForPlayer, isLoading: isLoading, isPlaying: isPlaying };
};
export var useSearchedTrackRelationToPlayer = function (trackId) {
    var isSelectedForPlayer = useIsSearchedTrackSelectedForPlayer(trackId);
    var isAudioLoading = useStore($isAudioLoading);
    var isAudioPlaying = useStore($isAudioPlaying);
    return {
        isSelectedForPlayer: isSelectedForPlayer,
        isLoading: isSelectedForPlayer && isAudioLoading,
        isPlaying: isSelectedForPlayer && isAudioPlaying,
    };
};
export var useUserFileRelationToPlayer = function (userFileId) {
    var isSelectedForPlayer = useIsUserFileSelectedForPlayer(userFileId);
    var isAudioLoading = useStore($isAudioLoading);
    var isAudioPlaying = useStore($isAudioPlaying);
    return {
        isSelectedForPlayer: isSelectedForPlayer,
        isLoading: isSelectedForPlayer && isAudioLoading,
        isPlaying: isSelectedForPlayer && isAudioPlaying,
    };
};
export var usePlaylistTrackRelationToPlayer = function (playlistTrackId) {
    var isSelectedForPlayer = useIsPlaylistTrackSelectedForPlayer(playlistTrackId);
    var isAudioLoading = useStore($isAudioLoading);
    var isAudioPlaying = useStore($isAudioPlaying);
    return {
        isSelectedForPlayer: isSelectedForPlayer,
        isLoading: isSelectedForPlayer && isAudioLoading,
        isPlaying: isSelectedForPlayer && isAudioPlaying,
    };
};
export var useTimetableRelationToPlayer = function (timetableId) {
    var isSelectedForPlayer = useIsTimetableSelectedForPlayer(timetableId);
    var isTrackSourceLoading = useIsThisTimetableLoading(timetableId);
    var isAudioLoading = useStore($isAudioLoading);
    var isAudioPlaying = useStore($isAudioPlaying);
    var isLoading = isSelectedForPlayer && (isTrackSourceLoading || isAudioLoading);
    var isPlaying = isSelectedForPlayer && isAudioPlaying;
    return { isSelectedForPlayer: isSelectedForPlayer, isLoading: isLoading, isPlaying: isPlaying };
};
